export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  TOGGLE_CONVERSATION_SEARCH: 'toggleConversationSearch',
  OPEN_CONVERSATION_SIDEBAR_TAB: 'openConversationSidebarTab',
  OPEN_FOLLOW_UP_MODAL: 'openFollowUpModalFromHeader',
  OPEN_APPOINTMENT_BOOKING: 'openAppointmentBooking',
  // Avisa a barra lateral que um compromisso foi criado/editado pelo modal do
  // header. Sem isto os dois são componentes irmãos que não se enxergam, e a
  // seção "Compromissos" só aparecia depois de F5 (visto pelo Victor, 02/09).
  SCHEDULED_ACTIVITY_SAVED: 'scheduledActivitySaved',
  // Abre o painel do Lumos já com uma pergunta feita (o Briefing do Dia usa
  // para "Perguntar ao Lumos"). Ouvido no CopilotContainer.
  LUMOS_PERGUNTAR: 'lumosPerguntar',
  // O "Seu dia" abriu: o Bom dia das Pendências fica quieto nesta carga (dois avisos seguidos, nunca).
  SEU_DIA_ABRIU: 'seuDiaAbriu',
};
